// 合单
import http from '@/services/http'
import type * as Types from './type'
import { createFnWithUrl } from '@/utils/createFnWithUrl'

/** 预合单-人工创建 */
export const preManualCreateOrder = (data: Types.ManualCreateOrderReq) => http.admin.post<Types.ManualCreateOrderRes>('/api/sales/outbounds/merge/pre/manual-create-order', data)

/** 预合单-修改cod、收货地址信息 */
export const preUpdate = createFnWithUrl((url, data: Types.PreUpdateReq) => http.admin.post(url, data), '/api/sales/outbounds/merge/pre/update')

/** 预合单-删除合单 */
export const preDeleteOrder = (data: Types.PreDeleteOrderReq) => http.admin.post('/api/sales/outbounds/merge/pre/delete-order', data)

/** 预合单-悬浮提示查看代收货款 */
export const preListTipCod = (data: Types.PreListTipCodReq) => http.admin.post<Types.PreListTipCodRes>('/api/sales/outbounds/merge/pre/list-tip-cod', data)

/** 预合单-悬浮提示查看商品 */
export const preListTipSku = (data: Types.PreListTipSkuReq) => http.admin.post<Types.PreListTipSkuRes>('/api/sales/outbounds/merge/pre/list-tip-sku', data)

/** 预合单-批量修改物流信息(仓库、物流渠道) */
export const preBatchUpdateOrder = (data: Types.PreBatchUpdateOrderReq) => http.admin.post('/api/sales/outbounds/merge/pre/batch-update-order', data)

/** 预合单-批量删除明细订单 */
export const preBatchDeleteDetail = (data: Types.PreBatchDeleteDetailReq) => http.admin.post('/api/sales/outbounds/merge/pre/batch-delete-detail', data)

/** 预合单-智能创建 */
export const preAutoCreateOrder = (data: Types.MergeOutboundAutoCreateReqDTO) => http.admin.post('/api/sales/outbounds/merge/pre/auto-create-order', data)

/** 合单数量查询 */
export const fetchMergeOrderCount = (data: Types.MergeOutboundAutoCountReqDTO) => http.toast.post<Types.CountStatisticsRes>('/api/sales/outbounds/merge/pre/count-statistics', data)

/** 预合单-查看合单明细 */
export const preListOrderDetail = (data: Types.PreListOrderDetailReq) => http.admin.post<Types.PreListOrderDetailRes>('/api/sales/outbounds/merge/pre/list-order-detail', data)

/**
 * 预合单-查看合单明细
 * @deprecated
 *  */
export const preSearchExcludeOrder = (data: Types.PreSearchExcludeOrderReq) =>
  http.admin.post<Types.PreSearchExcludeOrderRes>('/api/sales/outbounds/merge/pre/search-exclude-order', data)

/** 预合单-查询下拉地址列表 */
export const preListAddress = (data: Types.PreListAddressReq) => http.admin.post<Types.PreListAddressRes>('/api/sales/outbounds/merge/pre/list-address', data)

/** 预合单-查询分组 */
export const preGetGroup = (data: Types.PreGetGroupReq) => http.admin.post<Types.PreGetGroupRes>('/api/sales/outbounds/merge/pre/get-group', data)

/** 合单 */
export const mergeCreateOrder = (data: Types.MergeCreateOrderReq) => http.admin.post('/api/sales/outbounds/merge/create-order', data)

/** 批量取消合单 */
export const batchCancelMergeOrder = (data: Types.BatchCancelMergeOrderReq) => http.admin.post('/api/sales/outbounds/batch-cancel-merge-order', data)

/** 预合单-列表 */
// export const preList = (data: Types.PreListReq) => http.admin.post<Types.PreListRes>('/api/sales/outbounds/merge/pre/list', data)
export const preList = createFnWithUrl((url, data: Types.PreListReq) => http.admin.post<Types.PreListRes>(url, data), '/api/sales/outbounds/merge/pre/list')

/** 预合单-分组结果统计 */
export const preResultStatistics = (data: Types.ResultStatisticsReq) => http.admin.post<Types.ResultStatisticsRes>('/api/sales/outbounds/merge/pre/result-statistics', data)

/** 预合单-查看过滤订单 */
export const preListExcludeOrder = (data: Types.ListExcludeOrderReq) => http.admin.post<Types.ListExcludeOrderRes>('/api/sales/outbounds/merge/pre/list-exclude-order', data)

/** 预合单-查询失效分组 */
export const preListInvalidGroup = (data: Types.ListInvalidGroupReq) => http.admin.post<Types.ListInvalidGroupRes>('/api/sales/outbounds/merge/pre/list-invalid-group', data)
